import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { IndividualPayrocMerchantAccount } from './getPayrocMerchantAccounts';

export interface PayrocMerchantAccount extends IndividualPayrocMerchantAccount {
  businessId: number;
}

export interface AddPayrocMerchantAccountPayload {
  merchantId: string;
  businessId: number;
}

export const addPayrocMerchantAccount = ({
  merchantId,
  businessId,
}: AddPayrocMerchantAccountPayload): AxiosPromise<PayrocMerchantAccount> => {
  return httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/payroc/merchants/add`,
    data: {
      merchantId,
    },
  });
};
